document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('js-loaded');

  const parallaxElements = Array.from(document.querySelectorAll('[data-parallax]'));

  if (parallaxElements.length === 0) return;

  const parallaxItems = [];

  let isAnimating = false;
  let rafId = null;

  const startAnimation = () => {
    if (!isAnimating) {
      isAnimating = true;
      update();
    }
  };

  const update = () => {
    const windowHeight = window.innerHeight;

    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(update);

    parallaxItems.forEach((item) => {
      const rect = item.element.getBoundingClientRect();
      const s = (windowHeight - rect.y) / (windowHeight + rect.height) - item.initialProgressInScreen;
      let progress = s / (1 - item.initialProgressInScreen);
      progress = Math.max(0, Math.min(1, progress));

      const newValue = (item.endValue - item.startValue) * progress + item.startValue;
      const delta = newValue - item.currentValue;
      const step = Math.abs(delta) < 0.1 ? 0 : 0.1 * delta;

      item.currentValue += step;
      item.currentValue = parseFloat(item.currentValue.toFixed(3));

      if (Math.abs(delta) < 0.1 || !item.isInitialized) {
        item.currentValue = parseFloat(newValue.toFixed(3));
        item.isInitialized = true;
      }

      const transform = `translate3d(${item.xOffset}, ${item.currentValue}px, 0)`;
      item.element.style.transform = transform;
    });
  };

  const initParallax = () => {
    parallaxElements.forEach((el) => {
      const value = parseFloat(el.dataset.parallax || 0);
      const xOffset = el.dataset.parallaxXOffset || '0px';
      const rect = el.getBoundingClientRect();

      const startValue = (rect.y + rect.height + scrollY >= 0 && rect.y + scrollY < innerHeight)
        ? 0
        : -0.5 * value;
      const endValue = 0.5 * value;

      const initialProgressInScreen = Math.max(
        (window.innerHeight - rect.y - scrollY) / (window.innerHeight + rect.height),
        0
      );

      parallaxItems.push({
        element: el,
        startValue,
        endValue,
        currentValue: 0,
        isInitialized: false,
        initialProgressInScreen,
        xOffset,
      });
    });

    startAnimation();
  };

  initParallax();
});